import { createPinia } from 'pinia'
import { resetStore, currencyStore, actionsStore, gettersStore, pipelinesStore } from '@/stores/plugins'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()

pinia.use(resetStore)
pinia.use(currencyStore)
pinia.use(actionsStore)
pinia.use(gettersStore)
pinia.use(pipelinesStore)
pinia.use(piniaPluginPersistedstate)

export default pinia
